import { Icon } from '@chakra-ui/icon';
const LeftPagination = props => <Icon viewBox="0 0 6 10" {...props} data-sentry-element="Icon" data-sentry-component="LeftPagination" data-sentry-source-file="LeftPagination.tsx">
    <path d="M6 0L6 10L0 5L6 0Z" fill="currentColor" data-sentry-element="path" data-sentry-source-file="LeftPagination.tsx" />
  </Icon>;
LeftPagination.displayName = 'LeftPaginationIcon';
export default LeftPagination;